import { useTranslation } from 'next-i18next';
import styles from '@features/voxbox/sections/Contact/ContactSection.styles';
import { IContact } from '@features/voxbox/typescript';
import Heading from '@components/Heading/Heading';
import theme from '@styles/theme';
import Icon from '@components/icons/Icon';
import Button from '@components/Button/Button';
import { BASE_PATH } from '@config/index';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
type PropsType = {
  contact: IContact;
};
const ContactSection = ({
  contact
}: PropsType) => {
  const {
    t
  } = useTranslation('layouts');
  return <section sx={styles.section} data-cy="ContactSection">
      <div sx={styles.container}>
        <div sx={styles.video} data-cy="ContactSectionVideo">
          <ResponsiveImage image={`${BASE_PATH}/img/voxbox/goggle-vr.png`} alt="" objectFit="contain" objectPosition="bottom" />
          <a className="link-youtube-video" href={contact.videoUrl} target="_blank" rel="noreferrer" title={`${contact.header} ${t('footer.links.opensInNewWindow')}`}>
            <Icon addSx={styles.playerIcon} icon="Youtube" color="#FFF" size="100px" />
          </a>
        </div>
        <div sx={styles.descriptionWrapper} data-cy="ContactSectionContent">
          <Heading display={3} mobile color={theme.rawColors.neutralWhite}>
            {contact.header}
          </Heading>
          <p className="description-vr" data-cy="ContactSectionContentDescription">
            {contact.description}
          </p>
          <div sx={styles.mapBox} data-cy="ContactSectionContentImage">
            <ResponsiveImage image={`${BASE_PATH}/icons/map.svg`} width={107} height={86} objectFit="contain" alt="" />
            <p className="description-map">{contact.mapText}</p>
          </div>
          <Button variant="outlined" variantColor="white" href="/showroom">
            {contact.buttonText}
          </Button>
        </div>
      </div>
    </section>;
};
export default ContactSection;